import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BackToTop } from "@/components/ui/back-to-top";
import Loading from "@/components/ui/loading";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Suspense, useEffect, useState, lazy } from "react";
import ProductionProcess from "./pages/production-process";
import { ScrollToTop } from "@/components/ScrollToTop";

// Lazy load route components
const Index = lazy(() => import("./pages/Index"));
const NotFound = lazy(() => import("./pages/NotFound"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const Markets = lazy(() => import("./pages/Markets"));
const Manufacturing = lazy(() => import("./pages/Manufacturing"));
const ProductDetails = lazy(() => import("./pages/ProductDetails"));
const OurProducts = lazy(() => import("./pages/OurProducts"));

const queryClient = new QueryClient();

function RouteChangeLoader() {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsLoading(true);
    setIsLoading(false);
  }, [location]);

  return isLoading ? <Loading /> : null;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <Routes location={location} key={location.key}>
      <Route path="/" element={<Index />} />
      <Route path="/our-products" element={<OurProducts />} />
      <Route path="/products/:code" element={<ProductDetails />} />
      <Route path="/contactUs" element={<ContactUs />} />
      <Route path="/production-process" element={<ProductionProcess />} />
      {/* <Route path="/markets" element={<Markets />} />
      <Route path="/manufacturing" element={<Manufacturing />} /> */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <div className="relative w-full overflow-x-hidden">
            <ScrollToTop />
            <Suspense fallback={<Loading />}>
              <RouteChangeLoader />
              <AnimatedRoutes />
            </Suspense>
            <Toaster />
            <Sonner />
            <BackToTop />
          </div>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
